module.exports = __webpack_public_path__ + "static/collage-of-artworks-min-72626e5604253d9a406fac842b8a07c0.jpg";